// eslint-disable-next-line import/prefer-default-export
export const setDriverLocation = (data) => (dispatch) => {
  dispatch({ type: "SET_DRIVER_LOCATION", payload: data });
};
